<template>
  <v-layout>
    <v-col cols="12">
      <v-row class="row">
        <span class="legend-title">Обозначения:</span>
        <v-spacer/>
        <v-btn
            title="Скрыть"
            class="btn"
            :ripple="false"
            icon
            id="no-background-hover"
            @click="closeLegend">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-row>

      <item imageSrc="green.png"
                  description="- Концентрация загрязняющих веществ (ЗВ) на АПН ниже 1 ПДК" />
      <item imageSrc="yellow.png"
                  description="- Концентрация ЗВ на АПН от 1 до 10 ПДК" />
      <item imageSrc="red.png"
                  description="- Концентрация ЗВ на АПН выше 10 ПДК" />
      <item imageSrc="gray.png"
                  description="- Техническое обслуживание АПН" />
      <item imageSrc="blue.png"
                  description="- Система автоматического контроля промышленных выбросов" />

      <div class="flex">
        <span>АПН - Автоматизированный пост наблюдений за загрязнением атмосферного воздуха</span>
      </div>
    </v-col>
  </v-layout>
</template>

<script>
import LegendItem from "@/components/LegendItem.vue";
import {defineComponent} from "vue";
import {bus} from "@/main";

export default defineComponent({
  components: {"item": LegendItem},
  methods: {
    closeLegend() {
      bus.$emit('show-map-legend', false)
    }
  }
})
</script>

<style scoped>

.row {
  padding-bottom: 5px;
}

.legend-title {
  padding-top: 3px;
}

.btn {
  width: 26px;
  height:26px;
}

.flex {
  display: flex;
  align-items: center;
}
</style>
